(() => {
  const node = document.getElementById('GooseOptionLocalization');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const api = window.GooseOptions = {
    values: {},
    value(value) { return config.language === 'en' ? this.values[value] || value : value; },
    name(name) {
      if (/talla|size|tamaño/i.test(name)) return config.names.size;
      if (/color/i.test(name)) return config.names.color;
      if (/material/i.test(name)) return config.names.material;
      if (/^(ala|brim)$/i.test(name)) return config.names.brim;
      return name;
    },
    variant(title) { return String(title).split(' / ').map(value => this.value(value)).join(' / '); },
  sizeRange(value) {
    const fractions={'⅛':'1/8','¼':'1/4','⅜':'3/8','½':'1/2','⅝':'5/8','¾':'3/4','⅞':'7/8'};
    const text=String(value).replace(/[⅛¼⅜½⅝¾⅞]/g,fraction=>' '+fractions[fraction]).replace(/\s+/g,' ').trim();
    const usSizes={'6 3/8':51,'6 1/2':52,'6 5/8':53,'6 3/4':54,'6 7/8':55,'7':56,'7 1/8':57,'7 1/4':58,'7 3/8':59,'7 1/2':60,'7 5/8':61,'7 3/4':62,'7 7/8':63,'8':64};
    const usMatch=text.match(/(?:^|\s|\/)([6-8](?:\s+[1-7]\/[248])?)(?:\s*(?:-|–|a|to)\s*([6-8](?:\s+[1-7]\/[248])?))?(?=\s*(?:\/|$))/i);
    if(usMatch){const sizes=[usSizes[usMatch[1]],usSizes[usMatch[2]||usMatch[1]]];return sizes.every(Boolean)?sizes.sort((a,b)=>a-b):null;}
    const match=text.match(/(\d+(?:[.,]\d+)?)(?:\s*(?:-|–|a|to)\s*(\d+(?:[.,]\d+)?))?\s*-?\s*(cm|centimeters?|in(?:ches)?|")(?![a-z])/i);
    if(!match) {const bare=text.match(/^\d{2}$/);return bare&&Number(text)>=50&&Number(text)<=70?[Number(text),Number(text)]:null;}
    const factor=/^(?:in|")/i.test(match[3])?2.54:1;
    const sizes=[match[1],match[2]||match[1]].map(n=>Math.round(Number(n.replace(',','.'))*factor));
    return sizes.every(n=>n>=50&&n<=70)?sizes.sort((a,b)=>a-b):null;
  },
  compatible(value,size) {
    if(!size) return false;
    const range=this.sizeRange(value);
    if(range)return size>=range[0]&&size<=range[1];
    const text=String(value).trim().toUpperCase();
    if(/^(CH|S|SMALL)$/.test(text)) return size>=54&&size<=56;
    if(/^(M|MEDIUM)$/.test(text)) return size>=57&&size<=59;
    if(/^(G|L|LARGE)$/.test(text)) return size>=60&&size<=62;
    return /UNITALLA|AJUSTABLE|ONE SIZE|ADJUSTABLE|DEFAULT TITLE/.test(text);
  }
  };
  api.ready = fetch(node.dataset.url, {credentials:'same-origin'})
    .then(response => { if (!response.ok) throw new Error('Option translations unavailable'); return response.json(); })
    .then(data => { api.values = data.values.en; })
    .catch(error => console.warn(error.message));
  const applySwatches = (root) => {
    root.querySelectorAll('.swatch--gl').forEach(group => {
      const legend = group.querySelector('.name-option');
      if (legend) {
        const name = api.name(legend.dataset.name || legend.firstChild?.textContent || '');
        const text = [...legend.childNodes].find(child => child.nodeType === Node.TEXT_NODE);
        if (text && text.textContent !== name) text.textContent = name;
        const selected = group.querySelector('input[data-globoswatchindex]:checked');
        const current = legend.querySelector('.name-variant');
        if (current && selected) {
          const desired = ': ' + api.value(selected.value);
          if (current.textContent !== desired) current.textContent = desired;
        }
      }
      group.querySelectorAll('input[data-globoswatchindex]').forEach(input => {
        const translated = api.value(input.value);
        if (input.getAttribute('aria-label') !== translated) input.setAttribute('aria-label', translated);
        const label = input.nextElementSibling;
        if (label?.matches('label')) {
          const text = [...label.childNodes].find(child => child.nodeType === Node.TEXT_NODE);
          if (text && text.textContent !== translated) text.textContent = translated;
          if (label.title && label.title !== translated) label.title = translated;
        }
      });
    });
  };
  api.ready.then(() => {
    if (config.language !== 'en') return;
    document.querySelectorAll('product-info').forEach(root => {
      let queued = false;
      const update = () => { queued = false; applySwatches(root); };
      new MutationObserver(() => {
        if (!queued) { queued = true; requestAnimationFrame(update); }
      }).observe(root, {childList:true, subtree:true, characterData:true});
      root.addEventListener('change', update);
      update();
    });
  });
})();
